/**
 * Filter Group Component
 *
 * Individual filter component to reduce complexity of ContentFiltersForm.
 */

import { MultiSelect } from '@soteria/design-system-ve';

import * as styles from '../CreateAuditSessionDialog.css';

interface FilterOption {
  id: string;
  label: string;
  value: string;
}

interface FilterGroupProps {
  label: string;
  placeholder: string;
  options: FilterOption[];
  selectedValues: string[];
  disabled: boolean;
  loading: boolean;
  error?: string;
  onSelectionChange: (values: string[]) => void;
}

export function FilterGroup({ label, placeholder, options, selectedValues, disabled, loading, error, onSelectionChange }: FilterGroupProps) {
  return (
    <div className={styles.filterGroup}>
      <MultiSelect
        constrainToViewport
        disabled={disabled}
        error={error}
        label={label}
        loading={loading}
        options={options}
        placeholder={placeholder}
        selectedValues={selectedValues}
        showCheckboxes={false}
        onSelectionChange={onSelectionChange}
      />
    </div>
  );
}
